import React from 'react'
import PersonalInformation from '../../components/jsx/profile/ProfilePage/PersonalInformation/PersonalInformation'
import AddressInformation from '../../components/jsx/profile/ProfilePage/AddressInformation/AddressInformation'
import PersonalImageComponent from '../../components/jsx/profile/ProfilePage/PersonalImage/PersonalImageComponent'

const ProfilePage = () => {
    return (
        <>
            <div className='grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6'>
                <div className="col-span-1 md:col-span-12 lg:col-span-3">
                    <PersonalImageComponent />
                </div>
                <div className='col-span-1 md:col-span-12 lg:col-span-9 grid grid-rows-1 gap-4 md:gap-8'>
                    <PersonalInformation />
                    <AddressInformation />
                </div>
            </div>
        </>
    )
}

export default ProfilePage